export const isDevEnv = (fallback: boolean): boolean => {
  const viteMode = import.meta.env?.MODE as string | undefined;
  if (viteMode === 'production') {
    return false;
  }
  console.log(`[viteMode]: ${viteMode}`);
  if (viteMode === 'development') {
    return true;
  }

  return fallback;
};
